<template>
  <div>
    <component :is="componentId" @home="setHome" @login="setLogin"></component>
    <vue-headful :title="this.$clienteNomeFantasia + ' | Currículo Web'"></vue-headful>
  </div>
</template>

<script>
import Home from "./Home";
import Login from "./Login";

export default {
  data: () => ({
    componentId: Login
  }),
  mounted() {
    if (
      localStorage.getItem("codPessoa") !== null &&
      localStorage.getItem("senha") !== null
    ) {
      this.componentId = Home;
    }
  },
  methods: {
    setHome(val) {
      this.componentId = val;
    },
    setLogin(val) {
      this.componentId = val;
    }
  }
};
</script>
